// extracted by mini-css-extract-plugin
module.exports = {"reference":"ArticleInfo_reference__Tbaw2","colorSize":"ArticleInfo_colorSize__d25wX","info":"ArticleInfo_info__3f6AY","bullet":"ArticleInfo_bullet___Zer0"};